import styled, { createGlobalStyle, css } from 'styled-components';

import {
  Colors,
  ColorScheme,
  Fonts,
  OrderStatusColor,
} from 'styles/constants';
import type { DataTableAppearance } from './types';

interface TableSurfaceProps {
  $appearance: DataTableAppearance;
  $sticky?: boolean;
  $maxHeight?: string;
}

export const TableSurface = styled.div<TableSurfaceProps>`
  width: 100%;
  max-width: 100%;

  .pinned-left-edge::after {
    position: absolute;
    top: 0;
    right: -8px;
    bottom: 0;
    width: 8px;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.07), transparent);
    content: '';
    pointer-events: none;
  }

  tbody tr.doca-attention > td:first-child::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 4px;
    border-radius: 4px;
    background: ${OrderStatusColor.Iniciado};
    content: '';
    pointer-events: none;
  }

  ${({ $sticky, $maxHeight }) =>
    $sticky &&
    css`
      > div {
        max-height: ${$maxHeight};
        overflow-y: auto;
      }
    `}

  ${({ $appearance }) =>
    $appearance === 'default'
      ? css`
          border: 1px solid hsl(var(--border));
          border-radius: calc(var(--radius) - 2px);
          background: white;
        `
      : css`
          border: 0;
          border-radius: 0;
          background: transparent;

          table {
            border-collapse: separate;
            border-spacing: 0;
            color: ${ColorScheme.Text};
          }

          thead tr,
          tbody tr {
            border: 0;
          }

          tbody tr:hover {
            background: transparent;
          }

          th {
            height: auto;
            padding: 16px 12px;
            color: ${ColorScheme.Text};
            font-family: ${Fonts.GilroySemiBold};
            font-size: 11px;
            font-weight: normal;
            text-transform: uppercase;
          }

          th button,
          th span {
            font-family: ${Fonts.GilroySemiBold};
            font-size: 11px;
            text-transform: uppercase;
          }

          th button {
            height: auto;
            margin-left: 0;
            border: 0;
            padding: 0;
            background: transparent;
            color: inherit;

            &:hover {
              background: transparent;
              color: inherit;
            }
          }

          th button svg {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }

          td {
            padding: 8px 12px;
            color: ${ColorScheme.Text};
            font-family: ${Fonts.OpenSans};
            font-size: 12px;
            text-transform: uppercase;
          }
        `}
`;

export const GlobalDockAttentionBlink = createGlobalStyle`
  @keyframes dock-attention-blink {
    0%, 100% {
      background-color: ${Colors.Peach};
    }
    50% {
      background-color: #f9d4ba;
    }
  }

  .doca-blink {
    animation: dock-attention-blink 2.5s ease-in-out infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    .doca-blink {
      animation: none;
    }
  }
`;
